<template>
    <!-- Empty: no external tickets -->
    <div v-if="tickets.length === 0" class="row">
        <dt class="text-truncate col-sm-4 col-12 text-[14px] !font-medium">
            {{ trans('workorder.details.workorder.external_tickets.label') }}
        </dt>
        <dd class="col-sm-8 text-body-secondary col-12 mb-0 text-muted">
            {{ trans('workorder.details.workorder.external_tickets.empty') }}
        </dd>
    </div>

    <!-- Has tickets -->
    <div v-else class="row">
        <dt class="text-truncate col-sm-4 col-12 text-[14px] !font-medium">
            {{ trans('workorder.details.workorder.external_tickets.label') }}
        </dt>
        <dd class="col-sm-8 col-12 mb-0 text-muted">
            <div class="flex flex-wrap gap-1.5">
                <template v-for="ticket in tickets" :key="ticket.id">
                    <a
                        v-if="ticket.externalTicketUrl"
                        :href="ticket.externalTicketUrl"
                        v-c-tooltip="{ content: tooltipText(ticket) }"
                        :class="pillClasses(ticket)"
                        class="cursor-pointer no-underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {{ badgeLabel(ticket) }}
                    </a>
                    <span v-else v-c-tooltip="{ content: tooltipText(ticket) }" :class="pillClasses(ticket)">
                        {{ badgeLabel(ticket) }}
                    </span>
                </template>
            </div>
        </dd>
    </div>
</template>

<script setup>
import { trans } from '@/mixins/i18n.js';

defineProps({
    tickets: {
        type: Array,
        required: true,
    },
});

function pillClasses(ticket) {
    const base = 'inline-flex shrink-0 items-center rounded-md px-2 py-0 text-xs font-medium leading-5 no-underline';
    const colorMap = {
        provisioning: 'bg-info/10 text-info border border-info/20',
        active: 'bg-success/10 text-success border border-success/20',
        syncing: 'bg-warning/10 text-warning border border-warning/20',
        error: 'bg-danger/10 text-danger border border-danger/20',
        deleted: 'bg-secondary/10 text-muted border border-secondary/50',
    };
    return `${base} ${colorMap[ticket.bucket] ?? colorMap.deleted}`;
}

function badgeLabel(ticket) {
    if (ticket.externalId) {
        return `${ticket.adapterKey}: ${ticket.externalId}`;
    }
    return `${ticket.adapterKey}: ${trans(`workorder.external_tickets.bucket.${ticket.bucket}`)}`;
}

function tooltipText(ticket) {
    const status = trans(`workorder.external_tickets.bucket.${ticket.bucket}`);
    if (ticket.bucket === 'error' && ticket.errorMessage) {
        return `${status} — ${ticket.errorMessage}`;
    }
    return status;
}
</script>
